<template>
  <div>
    <div class="forecast-time-btn">
      <el-button v-if="permissionCodes.indexOf(`${permissionCode}`) !== -1 && isDisabled" class="modify-btn" @click="changeForecastTime" icon="el-icon-edit-outline">{{ forecastText }}</el-button>
      <el-button v-if="!isDisabled" class="confirm-btn" @click="changeForecastTime">{{ forecastText }}</el-button>
      <el-button v-if="!isDisabled" class="btn-cancel" @click="timeCancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import {bus} from "../../../../../utils/bus";
export default {
  name: "modifyConfig",
  props:{
    permissionCode: {
      type: String,
      default: ''
    },
    forecastText: String,
    isDisabled: Boolean,
  },
  data() {
    return {
      permissionCodes: ''
    }
  },
  mounted() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods:{
    // 保存
    saveDecimalPointConfig() {
      this.$emit('saveConfig');
    },

    // 修改配置
    changeForecastTime() {
      if (this.isDisabled) {
        this.$emit('modifyConfig');
      } else {
        this.saveDecimalPointConfig();
      }
    },

    // 点击取消
    timeCancel() {
      this.$emit('cancelConfig');
    },
  }
}
</script>

<style scoped>
.forecast-time-btn {
  color: #1362FF;
  cursor: pointer;
  display: flex;
  margin: 0.1rem 0.1rem 0.1rem 0;
}
.modify-btn {
  width: 0.46rem;
  height: 0.19rem;
  line-height: 0.19rem;
  font-size: 0.07rem;
  border: 1px solid #d7d7d7;
  color: #fff!important;
  padding: 8px 16px;
  background: #1362FF!important;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: center;
  border-radius: 0.02rem;
  margin-right: 0.08rem;
}
.modify-btn:hover {
  background-color: #06b3ff!important;
  color: #fff!important;
}
.confirm-btn:hover {
  background-color: #06b3ff !important;
  color: #fff!important;
}
.confirm-btn {
  width: 0.46rem;
  height: 0.19rem;
  line-height: 0.19rem;
  font-size: 0.09rem;
  border: 1px solid #d7d7d7;
  color: #fff!important;
  padding: 8px 16px;
  background: #1362FF!important;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: center;
  border-radius: 0.02rem;
  margin-right: 0.08rem;
}
.btn-cancel {
  width: 0.46rem;
  height: 0.19rem;
  line-height: 0.19rem;
  font-size: 0.09rem;
  border: 1px solid #d7d7d7;
  color: #fff;
  padding: 8px 16px;
  background: #1362FF;
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: center;
  border-radius: 0.02rem;
}
.btn-cancel:hover {
  background-color: #06b3ff;
  color: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/ApprovalConfig/components/btnConfig.vue